import type { ComponentType, ReactElement } from "react";

export const ContactLink = ({
  icon: Icon,
  label,
  href,
}: {
  icon: ComponentType<{ className?: string }>;
  label: string;
  href: string;
}): ReactElement => (
  <a
    href={href}
    className="text-primary inline-flex items-center gap-1.5 hover:underline"
    onClick={(event) => event.stopPropagation()}
  >
    <Icon className="size-3.5 shrink-0" />
    {label}
  </a>
);
